import React from "react";

const paths = {
  home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z" /></>,
  store: <><path d="M4 9h16v12H4zM3 9l2-6h14l2 6M9 21v-7h6v7M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" /></>,
  printer: <><path d="M6 8V3h12v5M6 17H3V8h18v9h-3M6 13h12v8H6z" /><path d="M17 10h1M9 16h6M9 18h4" /></>,
  chat: <><path d="M21 11a8 8 0 0 1-8 8H7l-5 3V11a9 9 0 0 1 18 0Z" /><path d="M7 10h9M7 14h5" /></>,
  user: <><circle cx="12" cy="7" r="4" /><path d="M4 21v-2a8 8 0 0 1 16 0v2" /></>,
  search: <><circle cx="10.5" cy="10.5" r="7" /><path d="m16 16 5 5" /></>,
  arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
  toner: <><path d="M5 8h14v13H5zM8 3h8v5M8 12h8M8 16h5" /></>,
  compare: <><path d="M4 5h5v16H4zM15 3h5v18h-5zM3 21h19" /></>,
  service: <><path d="m14 6 4 4 3-3a6 6 0 0 1-8 8l-6 6-4-4 6-6a6 6 0 0 1 8-8Z" /></>,
  phone: <path d="m8 3 2 5-3 2a15 15 0 0 0 7 7l2-3 5 2v4a2 2 0 0 1-2 2A20 20 0 0 1 2 5a2 2 0 0 1 2-2Z" />,
};

export default function AppIcon({ name, size = 24 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.printer}</svg>;
}
